/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import ReactFlow, { Controls, ReactFlowProvider } from "react-flow-renderer";

export const RenderToggelableFlow = ({
  elements = [],
  onElementsRemove = () => { },
  onConnect = () => { },
  onLoad = () => { },
  initElements = [],
  setActiveNode = () => { },
  layout = 'DEFAULT',
  panOnScroll = true,
  setToggled
}) => (
  <ReactFlowProvider>
    <ReactFlow
      elements={elements}
      onElementsRemove={onElementsRemove}
      onConnect={onConnect}
      onLoad={onLoad}
      selectNodesOnDrag={false}
      draggable={false}
      nodesDraggable={false}
      panOnScroll={panOnScroll}
      zoomOnScroll={panOnScroll}
      nodesConnectable={false}
      style={{ background: '#EFF4F8' }}
      onElementClick={(e) => {
        if (e.target) {
          if (e.target.classList) {
            if (!e.target.classList.contains('toggle-button')) {
              const id = e.currentTarget.getAttribute('data-id');
              const node = initElements.find((el) => el.id === id);

              if (node && node.config) {
                setActiveNode(node.config);
              }
            }
          }
        }
      }}
      onClick={(e) => {
        if (e.target) {
          if (e.target.className === 'react-flow__pane') {
            if (typeof setToggled === 'function') {
              setToggled(false);
            } else {
              setActiveNode(null);
            }
          }
        }
      }}
    >
      {layout === 'DEFAULT' && (
        <Controls />
      )}
    </ReactFlow>
  </ReactFlowProvider>
);